import axiosInstance from './axios-instance';


export const queryMentions = async (trigger: string, query: string) => {
    try {
      const response = await axiosInstance.get(`/api/v1/publisher/user/query-mentions`, {
        params: {
          query,
          trigger
        }
      });
      
      return response.data;
    } catch (error) {
      console.error("Error fetching mentions:", error);
      return [];
    }
  };